module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container",
    attrs: {
      "id": "mySwiper"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.bannerList), function(banner, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": banner.img,
        "mode": "aspectFill"
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e13b148"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JobCategory.vue
// module id = 238
// module chunks = 1